<template>
	<div class="wrapper">
		<div class="animated fadeIn">
			<genericTable :table-data="tableData" :fields="fields" :per-page=10 hover striped bordered small
										caption="Version List"></genericTable>
		</div>
	</div>
</template>

<script>
	import versionService from '@/services/versionService'
	import genericTable from '@/components/GenericTable'
	import Vue from 'vue'

	export default {
		name: 'Version',
		components: {
			"genericTable": genericTable
		},
		data: () => {
			return {
				versionList: [],
				fields: [
					{key: 'id', label: 'ID', sortable: true},
					{key: 'name', label: 'Name', sortable: true},
				],
			}
		},
		computed: {
			tableData() {
				return this.versionList
			}
		},
		methods: {
			getVersionListFromServer() {
				versionService.getVersionList((data) => {
					this.versionList = data;
				}, (error) => {
					Vue.toasted("Could not fetch version list" + error);
				});
			}
		},
		mounted() {
			this.getVersionListFromServer();
		}
	}
</script>
